import React, {Component} from "react";
import config from 'react-global-configuration';

class FallBackFilter extends Component {
    state = {
        is_fallback: false,
    };
    componentDidMount(){

    }
    resetFallBackFilter() {
        this.setState({
            is_fallback: 0,
        })
    }

    handleCheckFallback(e){
        var is_fallback = 1;
        if (e.target.checked === true) {
            this.setState({is_fallback: 1})
        } else {
            this.setState({is_fallback: 0});
            is_fallback = 0;
        }
        this.props.onSelectFallBack(is_fallback);
    }
    render() {
        return (
        <label>
            <input type="checkbox" name="is_fallback" onChange={this.handleCheckFallback.bind(this)}
            checked={(this.state.is_fallback == 1) ? true : false}/> &nbsp;  Fallback Flag </label>
        );

    }
}
export default FallBackFilter;